var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cert-card",attrs:{"target":"_blank","href":_vm.cert.downloadLink}},[_c('div',{staticClass:"cert-card-wrapper"},[_c('div',{staticClass:"cert-card__title"},[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.cert.course.title,100, '...'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }